import { emptyApi } from "./emptyApi";
import { DocumentTagReviewResponse } from "types/Models/documentTagReview";

export const documentTagReviewApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getDocumentTagReview: build.query<
      DocumentTagReviewResponse,
      { groupId: string; messageId: string; tagStatus?: number }
    >({
      query: ({ groupId, messageId, tagStatus }) => ({
        url: `/api/inkle/documents/admin/group/${groupId}/tag-review/`,
        params: { message_id: messageId, tag_status: tagStatus },
      }),
      providesTags: ["DOCUMENT_TAG_REVIEW"],
    }),

    confirmDocumentTags: build.mutation<
      void,
      {
        groupId: string;
        messageId?: string;
        documents: { document_id: string; tag_ids: string[] }[];
      }
    >({
      query: ({ groupId, messageId, documents }) => ({
        url: `/api/inkle/documents/admin/group/${groupId}/tag-review/`,
        method: "POST",
        body: { message_id: messageId, documents },
      }),
      invalidatesTags: [
        "DOCUMENT_TAG_REVIEW",
        "DOCUMENT_LIST",
        "RECENT_DOCUMENT",
        "DOCUMENT_REQUEST",
      ],
    }),
  }),

  overrideExisting: false,
});

export const { useGetDocumentTagReviewQuery, useConfirmDocumentTagsMutation } =
  documentTagReviewApi;
